import styled from "styled-components";
import { FlexDiv } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const PageTitleWrapper = styled(FlexDiv)`
  gap: 20px;
  padding: 8px 0;
  @media only screen and (max-width: 600px) {
    gap: 16px;
  }
`;

export const StyledPageTitle = styled(Typography)`
  color: ${theme.colorsV2.blue.shade_700};
`;
